export default __webpack_public_path__ + "resources/icons/n411-4419.webp";